import cookie from 'react-cookies';
import {
    CITYDOMAIN_COOKIE, COOKIE_MAX_AGE_LONG, COOKIE_MAX_AGE_SHORT,
} from '../constants';
import { getCookieDomain } from '~/src/helpers/city';
import Router from 'next/router';

export const getHostNameFromUrl = (url) => {
    const urlRegExp = /(.+:\/\/)?([^/]+)(\/.*)*/i;

    const urlParts = urlRegExp.exec(url);

    if (!urlParts || urlParts.length < 4) {
        return '';
    }

    return urlParts[2];
};

export const getCityFromHostName = (hostname = '') => {
    const hostParts = hostname.split('.');

    if (!hostParts.length) {
        return '';
    }

    return hostParts[0];
};

export const changeUrlCity = (citydomain, referrer, rememberMe = false) => {
    const cookieParams = {
        maxAge: rememberMe ? COOKIE_MAX_AGE_LONG : COOKIE_MAX_AGE_SHORT,
        domain: getCookieDomain(),
        path: '/',
    };
    cookie.save(CITYDOMAIN_COOKIE, citydomain, cookieParams);
    const { host, protocol } = location;

    let newHref = protocol + '//'  + host;

    if (referrer) {
        newHref += referrer;
    }

    location.replace(newHref);
};

/**
 * @param {string} referrer
 * @return {boolean}
 */
export function isLkReferrer(referrer) {
    const lkRegexp = /lk\.[\w.\/]+/;
    return lkRegexp.test(referrer);
}

/**
 * @param {Location|WorkerLocation} query
 * @return {object}
 */
export function getUrlParams(query) {
    const search = query.search.substr(1);
    const query_string = {};
    if (search) {
        let keyValuePair, paramName, paramValue;
        const str = search.split('#')[0];
        const params = str.split('&');

        for (let i = 0; i < params.length; i++) {
            keyValuePair = params[i].split('=');
            paramName = keyValuePair[0];
            paramValue = keyValuePair[1] || '';
            query_string[paramName] = decodeURIComponent(paramValue.replace(/\+/g, ' '));
        }
    }
    return query_string;
}

export const redirectingInGetInitialProps = (res, location, httpCode = 301) => {
    if (res) {
        res.writeHead(httpCode, {
            Location: location,
        });
        res.end();
    } else {
        Router.push(location);
    }
};

export const getUrlString = (params) => {
    const urlParams = Object.keys(params).map(key => {
        return `${key}=${params[key]}`;
    });
    return urlParams.length ? `${urlParams.join('&')}` : '';
};
